import script from "./HobbiesInterests.vue?vue&type=script&lang=ts&setup=true"
export * from "./HobbiesInterests.vue?vue&type=script&lang=ts&setup=true"

import "./HobbiesInterests.vue?vue&type=style&index=0&id=07ddd61c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ddd61c"]])

export default __exports__